<template>
  <NuxtLink v-if="data !== undefined" :to="data.link?.uri" class="teaser">
    <ResponsiveImage :image="data.image " />
    <div class="teaser__link">
      {{ data.link?.title }}
    </div>
  </NuxtLink>
</template>

<script setup lang="ts">
import { type ParagraphTeaserFragment } from '#graphql-operations'
defineProps<{
  data: ParagraphTeaserFragment
}>()

</script>

<style lang="scss">
@use "~/assets/sass/tools";

.teaser {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--grid-gutter);
  text-decoration: none;
  @include tools.to(tools.$breakpoint--desktop) {
    align-items: center;
  }

  &__link {
    @include tools.button;
  }
}
</style>
